import { IsOptional, IsString, IsEmail } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

/**
 * DTO pour synchroniser un utilisateur depuis Keycloak
 * NOTE: Backend-only, utilisé pour la synchronisation interne
 */
export class SyncFromKeycloakDto {
  @ApiPropertyOptional({ description: 'Email (cache Keycloak)' })
  @IsOptional()
  @IsEmail()
  email?: string

  @ApiPropertyOptional({ description: 'Username (cache Keycloak)' })
  @IsOptional()
  @IsString()
  username?: string

  @ApiPropertyOptional({ description: 'Prénom (cache Keycloak)' })
  @IsOptional()
  @IsString()
  firstName?: string

  @ApiPropertyOptional({ description: 'Nom (cache Keycloak)' })
  @IsOptional()
  @IsString()
  lastName?: string
}
